module.exports = __webpack_public_path__ + "static-portal/img/map-yyy2.90edfa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-yyy2.png
// module id = M9B8
// module chunks = 4